import type { EyewearHit } from '@/integrations/algolia/types';

const numberOfHits = 20;

export const eyewearFakePlpData = {
  hits: Array.from({ length: numberOfHits }).map(() => ({
    _metadata: {
      attrs_without_value: ['image_rolled_up_url', 'image_url'],
      updated_at_utc: '2025-05-15 12:16:11',
    },
    call_to_action: 'ORDER',
    call_to_action_for_phone: 'ORDER',
    call_to_action_weight: 4,
    case: {
      EN_US: 'Breitlight® | BREITL',
      ES: 'Breitlight® | BREITL',
      ZH_HANS: 'Breitlight® | BREITL',
    },
    case_en: 'Breitlight®',
    collection: 'Professional',
    collection_id: 'Q29sbGVjdGlvbjozNjM=',
    collections: [
      {
        name: 'Professional',
        slug: 'professional',
        id: 'Q29sbGVjdGlvbjozNjM=',
      },
    ],
    com_trace_story: null,
    com_trace_story_en: null,
    commercial_status: 'In Collection',
    components_expire_ts: 32503680000,
    components_preview: false,
    components_release_ts: 1719878400,
    currency: 'USD',
    deduplication_key: '',
    designer_choice: true,
    dial_color: {
      EN_US: 'Black | V-DIAL-COLOR-5686',
      ES: 'Negro | V-DIAL-COLOR-5686',
      ZH_HANS: '黑色 | V-DIAL-COLOR-5686',
    },
    dial_color_en: 'Black',
    ecomm_available: false,
    head_reference: 'X83310F6/BJ62',
    image_url:
      'https://www-breitling-int.eu.saleor.cloud/media/products/jz310601_25-soldier_a0ec6e4d.png',
    image_closed_url:
      'https://www-breitling-int.eu.saleor.cloud/media/products/BRSN-0001-50-01_3_b53777eb.jpg',
    launch_date: 32503680000,
    marketing_status: ['Core'],
    model: {
      name: {
        EN_US: 'Endurance Pro (38mm)',
        ES: 'Endurance Pro (38mm)',
        ZH_HANS: '专业耐力腕表(38mm)（Endurance Pro (38mm)）',
      },
      slug: 'endurance-pro-38mm',
    },
    model_en: 'Endurance Pro (38mm)',
    name: {
      EN_US: 'Léman',
      ES: 'Léman',
      ZH_HANS: 'Léman',
    },
    name_en: 'Léman',
    pdp_expire_ts: 32503680000,
    pdp_preview: false,
    pdp_release_ts: 1719878400,
    phone_sale_available: true,
    plp_expire_ts: 32503680000,
    plp_preview: false,
    plp_release_ts: 1719878400,
    price: 150,
    price_range: '0-5999',
    product_id: 'UHJvZHVjdDo5OTMw',
    product_type: 'Eyewear',
    publication_date: 1746706649,
    search_expire_ts: 32503680000,
    search_preview: false,
    search_release_ts: 1719878400,
    size: 38,
    size_range: '38-39',
    thumbnail_url:
      'https://www-breitling-int.eu.saleor.cloud/thumbnail/UHJvZHVjdE1lZGlhOjEyODI5Mw==/512/webp/',
    type: {
      EN_US: ['Men', 'Women', 'Professional'],
      ES: ['Hombre', 'Mujer', 'Profesional'],
      ZH_HANS: ['男士', '女士', '专业'],
    },
    type_en: ['Men', 'Women', 'Professional'],
    universe: 'Professional',
    variant_id: 'UHJvZHVjdFZhcmlhbnQ6Nzk0OA==',
    wholesaler_ids: ['0aa2e18dc6f2b56425265acc9f06308a'],
    widget_expire_ts: 32503680000,
    widget_is_top_range: false,
    widget_preview: false,
    widget_release_ts: 1719878400,
    widget_stock_in_wholesaler_ids: [],
    core_wire_en: '18k red gold milanese engraved',
    description_en:
      'A fusion of Swiss precision and British craftsmanship, designed with meticulous attention to detail. Breitling’s timeless aesthetic meets Cutler and Gross’s handcrafted eyewear in a new sunglasses collaboration inspired by the Superocean Heritage watch collection. This pair features Milanese beveling borrowed from the mesh bracelet of the Superocean Heritage on the bridge and temples as well as spearhead-shaped temple tips resembling the watch’s hands and indexes. Available with adjustable nose pads and palladium frames in black, blue or green lenses  or as a limited-edition of 500 featuring Zeiss LightPro® lenses and 18k red gold-plated metalwork. All pairs of sunglasses offer UV400 UVA and UVB protection—ensuring comfort and effortless style at sea.',
    frame_color_en: 'Silver & black',
    frame_material_en: 'Metal & bioplastic cellulose acetate',
    frame_shape_en: 'Square',
    frontal_pins_en: 'Milanese engraved',
    lens_color_en: 'Blue | V-LENS-COLOR-3001',
    nose_pads_en: 'Adjustable nose pads',
    short_description_en:
      'Handcrafted in Italy, this pair of sunglasses complements the design codes of Breitling’s classic Superocean Heritage sea watch with details like Milanese beveling on the temples and bridge and arrow temple tips that draw inspiration from elements of the watch’s dial and bracelet.\ng',
    temple_tip_detail_en: 'Luminous arrowhead on inner temples',
    uv_protection_en: 'UV400 UVA & UVB protection',
    bridge_width: 21,
    core_wire: {
      EN_US: '18k red gold milanese engraved',
      ES: '18k red gold milanese engraved',
      ZH_HANS: '18k red gold milanese engraved',
    },
    description: {
      EN_US:
        'A fusion of Swiss precision and British craftsmanship, designed with meticulous attention to detail. Breitling’s timeless aesthetic meets Cutler and Gross’s handcrafted eyewear in a new sunglasses collaboration inspired by the Superocean Heritage watch collection. This pair features Milanese beveling borrowed from the mesh bracelet of the Superocean Heritage on the bridge and temples as well as spearhead-shaped temple tips resembling the watch’s hands and indexes. Available with adjustable nose pads and palladium frames in black, blue or green lenses  or as a limited-edition of 500 featuring Zeiss LightPro® lenses and 18k red gold-plated metalwork. All pairs of sunglasses offer UV400 UVA and UVB protection—ensuring comfort and effortless style at sea.',
      ES: 'A fusion of Swiss precision and British craftsmanship, designed with meticulous attention to detail.',
      ZH_HANS:
        'A fusion of Swiss precision and British craftsmanship, designed with meticulous attention to detail.',
    },
    frame_color: {
      EN_US: 'Silver & black',
      ES: 'Silver & black',
      ZH_HANS: 'Silver & black',
    },
    frame_material: {
      EN_US: 'Metal & bioplastic cellulose acetate',
      ES: 'Metal & bioplastic cellulose acetate',
      ZH_HANS: 'Metal & bioplastic cellulose acetate',
    },
    frame_shape: {
      EN_US: 'Square',
      ES: 'Square',
      ZH_HANS: 'Square',
    },
    frontal_pins: {
      EN_US: 'Milanese engraved',
      ES: 'Milanese engraved',
      ZH_HANS: 'Milanese engraved',
    },
    frontal_width: 140,
    image_rolled_up_url:
      'https://www-breitling-int.eu.saleor.cloud/media/products/jz310601_25-rolled-up_1def3b20.png',
    lens_color: {
      EN_US: 'Blue | V-LENS-COLOR-3001',
      ES: 'Azul | V-LENS-COLOR-3001',
      ZH_HANS: '蓝色 | V-LENS-COLOR-3001',
    },
    lens_width: 50,
    nose_pads: {
      EN_US: 'Adjustable nose pads',
      ES: 'Adjustable nose pads',
      ZH_HANS: 'Adjustable nose pads',
    },
    reference: 'JZ310601.25',
    short_description: {
      EN_US:
        'Handcrafted in Italy, this pair of sunglasses complements the design codes of Breitling’s classic Superocean Heritage sea watch with details like Milanese beveling on the temples and bridge and arrow temple tips that draw inspiration from elements of the watch’s dial and bracelet.\ng',
      ES: 'Handcrafted in Italy, this pair of sunglasses complements the design codes of Breitling’s classic Su',
      ZH_HANS:
        'Handcrafted in Italy, this pair of sunglasses complements the design codes of Breitling’s classic Su',
    },
    temple_length: 150,
    temple_tip_detail: {
      EN_US: 'Luminous arrowhead on inner temples',
      ES: 'Luminous arrowhead on inner temples',
      ZH_HANS: 'Luminous arrowhead on inner temples',
    },
    uv_protection: {
      EN_US: 'UV400 UVA & UVB protection',
      ES: 'UV400 UVA & UVB protection',
      ZH_HANS: 'UV400 UVA & UVB protection',
    },
    weight: 0.2,
    weight_unit: 'GRM',
    objectID: `JZ310601.25`,
  })),
  nbHits: numberOfHits,
  page: 0,
  nbPages: 1,
  hitsPerPage: 20,
  exhaustiveNbHits: true,
  query: '',
  params: '',
  processingTimeMS: 1,
  facets: {
    size: {
      '42.0': 36,
      '44.0': 33,
      '36.0': 28,
      '41.0': 16,
      '46.0': 13,
      '43.0': 6,
      '38.0': 5,
      '40.0': 3,
      '51.0': 2,
      '32.0': 1,
    },
    price: {
      '5250.0': 6,
      '5400.0': 6,
      '5150.0': 5,
      '8550.0': 5,
      '9950.0': 5,
      '3700.0': 4,
      '5500.0': 4,
      '9750.0': 4,
      '5050.0': 3,
      '8650.0': 3,
      '9450.0': 3,
      '9550.0': 3,
      '9700.0': 3,
      '9800.0': 3,
      '10800.0': 2,
      '11250.0': 2,
      '13200.0': 2,
      '13750.0': 2,
      '16200.0': 2,
      '21200.0': 2,
      '26400.0': 2,
      '5450.0': 2,
      '6050.0': 2,
      '6450.0': 2,
      '7300.0': 2,
      '8250.0': 2,
      '8600.0': 2,
      '8900.0': 2,
      '8950.0': 2,
      '9650.0': 2,
    },
    'case.EN_US': {
      'Stainless steel | STSTL': 85,
      'Stainless steel & 18k red gold | STNSTL_18KREG': 15,
      '18k red gold | 18KREG': 14,
      'Breitlight® | BREITL': 6,
      'Stainless steel (gem-set) | STNSTL_GEM': 4,
      'Small scale traceable 18K red gold | BETTERGOLD': 3,
      'Stainless steel & 18k red gold (gem-set) | STNSTL_18KREG_GEM': 3,
      'Stainless steel & 18k white gold | SS_18KWHGLD': 3,
      'Titanium | TITNM': 3,
      'Bronze | BRNZ': 2,
      'Stainless steel & platinum | SS_PLAT': 2,
      'DLC-coated stainless steel | DLCCSSTL': 1,
      'DLC-coated titanium | DLC_CTI': 1,
      'Platinum | PLTNM': 1,
    },
    collection: {
      Chronomat: 46,
      Navitimer: 23,
      Superocean: 18,
      'Superocean Heritage': 18,
      Premier: 10,
      Professional: 8,
      Avenger: 7,
      'Classic AVI': 7,
      'Top Time': 6,
    },
    'type.EN_US': {
      Men: 135,
      'Breitling Manufacture Calibers': 75,
      Women: 73,
      Gold: 18,
      Limited: 8,
      Professional: 8,
      Titanium: 4,
      Blacksteel: 1,
    },
    'dial_color.EN_US': {
      'Black | V-DIAL-COLOR-5686': 32,
      'Blue | V-DIAL-COLOR-5714': 26,
      'Green | V-DIAL-COLOR-5765': 23,
      'Cream | V-DIAL-COLOR-5842': 12,
      'White | V-DIAL-COLOR-5926': 8,
      'Ice blue | V-DIAL-COLOR-1111': 6,
      'Mint green | V-DIAL-COLOR-8888': 6,
      'Anthracite | V-DIAL-COLOR-5664': 5,
      'Copper | V-DIAL-COLO-999': 5,
      'Mother-of-pearl | V-DIAL-COLOR-5791': 5,
      'Silver | V-DIAL-COLOR-5843': 3,
      'Beige | V-DIAL-COLOR-5969': 2,
      'Brown | V-DIAL-COLOR-5723': 2,
      'Red | V-DIAL-COLOR-556644': 2,
      'Bronze | V-DIAL-COLOR-5720': 1,
      'Midnight blue | V-DIAL-COLOR-445566': 1,
      'Orange | V-DIAL-COLOR-5800': 1,
      'Pink mother-of-pearl | V-DIAL-COLOR-6666': 1,
      'Turquoise | V-DIAL-COLOR-9876': 1,
      'Yellow | VDIALCOLOR9999': 1,
    },
  },
  exhaustiveFacetsCount: true,
  exhaustiveTypo: true,
  exhaustive: {
    facetsCount: true,
    nbHits: true,
    typo: true,
  },
  renderingContent: {
    facetOrdering: {
      facets: {
        order: [
          'case.EN_US',
          'case.ES',
          'case.ZH_HANS',
          'collections.name',
          'size',
          'type.EN_US',
          'type.ES',
          'type.ZH_HANS',
          'color.EN_US',
          'color.ES',
          'color.ZH_HANS',
          'material.EN_US',
          'material.ES',
          'material.ZH_HANS',
          'dial_color.EN_US',
          'dial_color.ES',
          'dial_color.ZH_HANS',
          'lug_size',
          'distance_between_horns.EN_US',
          'distance_between_horns.ES',
          'distance_between_horns.ZH_HANS',
          'strap_length.EN_US',
          'strap_length.ES',
          'strap_length.ZH_HANS',
          'buckle_type.EN_US',
          'buckle_type.ES',
          'buckle_type.ZH_HANS',
          'price',
        ],
      },
      values: {
        'buckle_type.EN_US': {
          sortRemainingBy: 'count',
        },
        'buckle_type.ES': {
          sortRemainingBy: 'count',
        },
        'buckle_type.ZH_HANS': {
          sortRemainingBy: 'count',
        },
        'case.EN_US': {
          sortRemainingBy: 'count',
        },
        'case.ES': {
          sortRemainingBy: 'count',
        },
        'case.ZH_HANS': {
          sortRemainingBy: 'count',
        },
        'collections.name': {
          sortRemainingBy: 'count',
        },
        'color.EN_US': {
          sortRemainingBy: 'count',
        },
        'color.ES': {
          sortRemainingBy: 'count',
        },
        'color.ZH_HANS': {
          sortRemainingBy: 'count',
        },
        'dial_color.EN_US': {
          sortRemainingBy: 'count',
        },
        'dial_color.ES': {
          sortRemainingBy: 'count',
        },
        'dial_color.ZH_HANS': {
          sortRemainingBy: 'count',
        },
        'distance_between_horns.EN_US': {
          sortRemainingBy: 'count',
        },
        'distance_between_horns.ES': {
          sortRemainingBy: 'count',
        },
        'distance_between_horns.ZH_HANS': {
          sortRemainingBy: 'count',
        },
        lug_size: {
          sortRemainingBy: 'count',
        },
        'material.EN_US': {
          sortRemainingBy: 'count',
        },
        'material.ES': {
          sortRemainingBy: 'count',
        },
        'material.ZH_HANS': {
          sortRemainingBy: 'count',
        },
        price: {
          sortRemainingBy: 'count',
        },
        size: {
          sortRemainingBy: 'count',
        },
        'strap_length.EN_US': {
          sortRemainingBy: 'count',
        },
        'strap_length.ES': {
          sortRemainingBy: 'count',
        },
        'strap_length.ZH_HANS': {
          sortRemainingBy: 'count',
        },
        'type.EN_US': {
          sortRemainingBy: 'count',
        },
        'type.ES': {
          sortRemainingBy: 'count',
        },
        'type.ZH_HANS': {
          sortRemainingBy: 'count',
        },
      },
    },
  },
};

export const eyewearHitMock: EyewearHit = {
  call_to_action: 'ORDER',
  call_to_action_for_phone: 'ORDER',
  call_to_action_weight: 4,
  commercial_status: 'In Collection',
  components_expire_ts: 32503680000,
  components_preview: false,
  components_release_ts: 1719878400,
  currency: 'USD',
  deduplication_key: '',
  designer_choice: true,
  ecomm_available: false,
  head_reference: 'X83310F6/BJ62',
  image_url:
    'https://www-breitling-int.eu.saleor.cloud/media/products/jz310601_25-soldier_a0ec6e4d.png',
  launch_date: 32503680000,
  marketing_status: ['Core'],
  model: {
    name: {
      EN_US: 'Endurance Pro (38mm)',
      ES: 'Endurance Pro (38mm)',
      ZH_HANS: '专业耐力腕表(38mm)（Endurance Pro (38mm)）',
    },
    slug: 'endurance-pro-38mm',
  },
  model_en: 'Endurance Pro (38mm)',
  name: {
    EN_US: 'Léman',
    ES: 'Léman',
    ZH_HANS: 'Léman',
  },
  name_en: 'Léman',
  pdp_expire_ts: 32503680000,
  pdp_preview: false,
  pdp_release_ts: 1719878400,
  phone_sale_available: true,
  plp_expire_ts: 32503680000,
  plp_preview: false,
  plp_release_ts: 1719878400,
  price: 150,
  price_range: '0-5999',
  product_id: 'UHJvZHVjdDo5OTMw',
  product_type: 'Eyewear',
  publication_date: 1746706649,
  search_expire_ts: 32503680000,
  search_preview: false,
  search_release_ts: 1719878400,
  thumbnail_url:
    'https://www-breitling-int.eu.saleor.cloud/thumbnail/UHJvZHVjdE1lZGlhOjEyODI5Mw==/512/webp/',
  type: {
    EN_US: ['Men', 'Women', 'Professional'],
    ES: ['Hombre', 'Mujer', 'Profesional'],
    ZH_HANS: ['男士', '女士', '专业'],
  },
  type_en: ['Men', 'Women', 'Professional'],
  variant_id: 'UHJvZHVjdFZhcmlhbnQ6Nzk0OA==',
  widget_expire_ts: 32503680000,
  widget_preview: false,
  widget_release_ts: 1719878400,
  widget_stock_in_wholesaler_ids: [],
  frame_color_en: 'Silver & black',
  frame_material_en: 'Metal & bioplastic cellulose acetate',
  frame_shape_en: 'Square',
  lens_color_en: 'Blue | V-LENS-COLOR-3001',
  bridge_width: '21',
  description: {
    EN_US:
      'A fusion of Swiss precision and British craftsmanship, designed with meticulous attention to detail. Breitling’s timeless aesthetic meets Cutler and Gross’s handcrafted eyewear in a new sunglasses collaboration inspired by the Superocean Heritage watch collection. This pair features Milanese beveling borrowed from the mesh bracelet of the Superocean Heritage on the bridge and temples as well as spearhead-shaped temple tips resembling the watch’s hands and indexes. Available with adjustable nose pads and palladium frames in black, blue or green lenses  or as a limited-edition of 500 featuring Zeiss LightPro® lenses and 18k red gold-plated metalwork. All pairs of sunglasses offer UV400 UVA and UVB protection—ensuring comfort and effortless style at sea.',
    ES: 'A fusion of Swiss precision and British craftsmanship, designed with meticulous attention to detail.',
    ZH_HANS:
      'A fusion of Swiss precision and British craftsmanship, designed with meticulous attention to detail.',
  },
  frame_color: {
    EN_US: 'Silver & black',
    ES: 'Silver & black',
    ZH_HANS: 'Silver & black',
  },
  frame_material: {
    EN_US: 'Metal & bioplastic cellulose acetate',
    ES: 'Metal & bioplastic cellulose acetate',
    ZH_HANS: 'Metal & bioplastic cellulose acetate',
  },
  frame_shape: {
    EN_US: 'Square',
    ES: 'Square',
    ZH_HANS: 'Square',
  },
  frontal_pins: {
    EN_US: 'Milanese engraved',
    ES: 'Milanese engraved',
    ZH_HANS: 'Milanese engraved',
  },
  frontal_width: 140,
  image_rolled_up_url:
    'https://www-breitling-int.eu.saleor.cloud/media/products/jz310601_25-rolled-up_1def3b20.png',
  lens_color: {
    EN_US: 'Blue | V-LENS-COLOR-3001',
    ES: 'Azul | V-LENS-COLOR-3001',
    ZH_HANS: '蓝色 | V-LENS-COLOR-3001',
  },
  lens_width: '50',
  nose_pads: {
    EN_US: 'Adjustable nose pads',
    ES: 'Adjustable nose pads',
    ZH_HANS: 'Adjustable nose pads',
  },
  reference: 'JZ310601.25',
  short_description: {
    EN_US:
      'Handcrafted in Italy, this pair of sunglasses complements the design codes of Breitling’s classic Superocean Heritage sea watch with details like Milanese beveling on the temples and bridge and arrow temple tips that draw inspiration from elements of the watch’s dial and bracelet.\ng',
    ES: 'Handcrafted in Italy, this pair of sunglasses complements the design codes of Breitling’s classic Su',
    ZH_HANS:
      'Handcrafted in Italy, this pair of sunglasses complements the design codes of Breitling’s classic Su',
  },
  temple_length: '150',
  temple_tip_detail: {
    EN_US: 'Luminous arrowhead on inner temples',
    ES: 'Luminous arrowhead on inner temples',
    ZH_HANS: 'Luminous arrowhead on inner temples',
  },
  uv_protection: {
    EN_US: 'UV400 UVA & UVB protection',
    ES: 'UV400 UVA & UVB protection',
    ZH_HANS: 'UV400 UVA & UVB protection',
  },
  weight: 0.2,
  weight_unit: 'GRM',
  objectID: `JZ310601.25`,
};
